import React from 'react';
import './Service.css';
import Image1 from '../../../Gemco-Website-Images/Services/construction_pipe.jpg';
import Image2 from '../../../Gemco-Website-Images/Services/Industrial_plants.jpg';
import Image3 from '../../../Gemco-Website-Images/Services/Electrical_panel.jpg';
import Image4 from '../../../Gemco-Website-Images/Services/Building_renovation.jpg';
import Image5 from '../../../Gemco-Website-Images/Services/maintenance_engineer.jpg';
import Image6 from '../../../Gemco-Website-Images/Services/terrazzo_floor.jpg';
import Image7 from '../../../Gemco-Website-Images/Services/Commercial_Kitchen_MEP.jpg';

const Service = () => {
  return (
    <div className='wp_service_wrap'>
       <div className="container wp_service_container">
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image1} alt="" />
                    </div>
                    <h5 class="card-title text-white">MEP Supply and Installation</h5>
                    <div className="card-text wp_service_card_text">
                        <a href=""><p>Gandhi Electro Mechanical Co. LLC delivers the complete spectrum of mechanical, electrical</p></a>
                    </div><br />
                    <a href="/services/service/1" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image2} alt="" />
                    </div>
                    <h5 class="card-title text-white">CHW & District Cooling</h5>
                    <div className="card-text">
                        <a href="/services/service/2"><p>GEMCO's deepest and most technically advanced capability. Over 25 years delivering chilled</p></a>
                    </div><br />
                    <a href="/services/service/2" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image3} alt="" />
                    </div>
                    <h5 class="card-title text-white">Power Upgrade Works</h5>
                    <div className="card-text">
                        <a href=""><p>Complete LV electrical infrastructure upgrades for operating facilities — carried out safely with</p></a>
                    </div><br />
                    <a href="/services/service/3" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image4} alt="" />
                    </div>
                    <h5 class="card-title text-white">Retrofit and Refurbishment Works</h5>
                    <div className="card-text">
                        <a href=""><p>Full MEP retrofit capability for occupied or recently vacated buildings — hotels, malls, offices</p></a>
                    </div><br />
                    <a href="/services/service/4" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image5} alt="" />
                    </div>
                    <h5 class="card-title text-white">Facility Maintenance — AMC</h5>
                    <div className="card-text">
                        <a href=""><p>Annual maintenance contracts for HVAC systems, electrical panels, and specialist civil</p></a>
                    </div><br />
                    <a href="/services/service/5" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image6} alt="" />
                    </div>
                    <h5 class="card-title text-white">Specialist Civil Works</h5>
                    <div className="card-text">
                        <a href=""><p>A unique capability that differentiates GEMCO — specialist interior civil works delivered</p></a>
                    </div><br />
                    <a href="/services/service/6" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
        <div className="card wp_service_card">
            <div className="row">
                <div className="card-body">
                    <div className="card-title wp_service_card_title">
                        <img fetchpriority="high" decoding="async" src={Image7} alt="" />
                    </div>
                    <h5 class="card-title text-white">Commercial Kitchen MEP</h5>
                    <div className="card-text">
                        <a href=""><p>Complete MEP scope for commercial kitchens in hotels, restaurants and food operations</p></a>
                    </div><br />
                    <a href="/services/service/7" className='wp_service_btn'>View More</a>
                </div>
            </div>
        </div>
       </div>
    </div>
  )
}

export default Service